const kl_coll =window.productCollection;
// console.log(kl_coll);

addEventListener("load", (event) => {
    fetch(`${location.href.split("?")[0]}.json`)
        .then((resVariant) => resVariant.json())
        .then((data) => {
            let variant = data.product.variants[0]
            var formattedItem = {
                "Name": data.product.title,
                "ProductID": data.product.id,
                "Categories": kl_coll,
                "ImageURL": data.product.image.src,
                "URL": `${window.location.href}`,
                "Brand": data.product.vendor,
                "Price": `$${variant.price}`,
                "CompareAtPrice": `$${variant.compare_at_price}`,
                "variant_id": variant.id,
                "variant": variant
            }
          
            klaviyo.track("Viewed Product", formattedItem)
        }).catch((error) => {});
});